var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useCallback, useRef } from 'react';
import { makeStyles } from 'tss-react/mui';
import { v4 as uuidv4 } from 'uuid';
import { translate } from '../../base/i18n/functions';
import Icon from '../../base/icons/components/Icon';
import { IconPlusCircle } from '../../base/icons/svg';
import { VIRTUAL_BACKGROUND_TYPE } from '../constants';
import { resizeImage } from '../functions';
import logger from '../logger';
// @ts-ignore
const useStyles = makeStyles()((theme) => {
    return {
        addBackground: {
            marginRight: theme.spacing(2)
        },
        button: {
            display: 'none'
        },
        label: {
            fontSize: '14px',
            fontWeight: '600',
            lineHeight: '20px',
            marginTop: theme.spacing(3),
            marginBottom: theme.spacing(2),
            color: '#669aec',
            display: 'inline-flex',
            cursor: 'pointer'
        }
    };
});
/**
 * Component used to upload an image.
 *
 * @param {Object} Props - The props of the component.
 * @returns {React$Node}
 */
function UploadImageButton({ setLoading, setOptions, setStoredImages, showLabel, storedImages, t }) {
    const { classes } = useStyles();
    const uploadImageButton = useRef(null);
    const uploadImageKeyPress = useCallback(e => {
        if (uploadImageButton.current && (e.key === ' ' || e.key === 'Enter')) {
            e.preventDefault();
            uploadImageButton.current.click();
        }
    }, [uploadImageButton.current]);
    const uploadImage = useCallback((e) => __awaiter(this, void 0, void 0, function* () {
        const reader = new FileReader();
        const imageFile = e.target.files;
        reader.readAsDataURL(imageFile[0]);
        reader.onload = () => __awaiter(this, void 0, void 0, function* () {
            const url = yield resizeImage(reader.result);
            const uuId = uuidv4();
            setStoredImages([
                ...storedImages,
                {
                    id: uuId,
                    src: url
                }
            ]);
            setOptions({
                backgroundType: VIRTUAL_BACKGROUND_TYPE.IMAGE,
                enabled: true,
                url,
                selectedThumbnail: uuId
            });
        });
        logger.info('New virtual background image uploaded!');
        reader.onerror = () => {
            setLoading(false);
            logger.error('Failed to upload virtual image!');
        };
    }), [storedImages]);
    return (React.createElement(React.Fragment, null,
        showLabel && React.createElement("label", { "aria-label": t('virtualBackground.uploadImage'), className: classes.label, htmlFor: 'file-upload', onKeyPress: uploadImageKeyPress, tabIndex: 0 },
            React.createElement(Icon, { className: classes.addBackground, size: 20, src: IconPlusCircle }),
            t('virtualBackground.addBackground')),
        React.createElement("input", { accept: 'image/*', className: classes.button, id: 'file-upload', onChange: uploadImage, ref: uploadImageButton, type: 'file' })));
}
export default translate(UploadImageButton);
